import { render, staticRenderFns } from "./GestaoCargaUnidadeCargaTrechoForm.vue?vue&type=template&id=794f91b8"
import script from "./GestaoCargaUnidadeCargaTrechoForm.vue?vue&type=script&lang=js"
export * from "./GestaoCargaUnidadeCargaTrechoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports